import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx, jsxs } from 'react/jsx-runtime';

var Svg24LinkchannelG = /*#__PURE__*/React.memo(function (props) {
  var theme = useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /*#__PURE__*/jsxs("g", {
      fill: props.iconColor ? props.iconColor : theme === null || theme === void 0 ? void 0 : theme.colorV2.colorSet.grey400,
      fillRule: "nonzero",
      children: [/*#__PURE__*/jsx("path", {
        d: "M20.254 14.31c-.4 0-.724.323-.724.723v3.046c0 .801-.648 1.452-1.45 1.454H5.897a1.454 1.454 0 0 1-1.45-1.454V5.895c.004-.8.651-1.446 1.45-1.448h3.047a.723.723 0 0 0 0-1.447H5.897A2.9 2.9 0 0 0 3 5.897V18.08a2.9 2.9 0 0 0 2.897 2.897H18.08a2.9 2.9 0 0 0 2.897-2.897v-3.046a.723.723 0 0 0-.724-.725"
      }), /*#__PURE__*/jsx("path", {
        d: "M20.921 3.447A.73.73 0 0 0 20.254 3h-6.96a.723.723 0 0 0 0 1.447h5.213l-5.725 5.725a.723.723 0 0 0 1.024 1.022L19.53 5.47v5.216a.723.723 0 1 0 1.447 0V3.723a.7.7 0 0 0-.056-.276"
      })]
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg24LinkchannelG$1 = Svg24LinkchannelG;

export { Svg24LinkchannelG$1 as default };
